import React from 'react';
import Guide from '@/assets/icon/Guide.svg';
import cx from './index.module.scss';

interface CustomLabelProps {
  label: string;
  desc: string;
  children?: React.ReactNode;
  classNames?: string;
}

const CustomLabel: React.FC<CustomLabelProps> = props => {
  const { label, desc, children, classNames } = props;

  return (
    <div className={cx('pain-level', classNames)}>
      <div className={cx('tips')}>
        <span className={cx('title')}>{label}</span>
        <img src={Guide} alt="guide" />
        <span className={cx('desc')}>{desc}</span>
      </div>
      <div className={cx('content')}>{children}</div>
    </div>
  );
};

export default CustomLabel;
